import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col } from 'antd';

import { useLibertyMutualContext } from '../../../context';
import { Topic, Value } from './styles';

export const CompanyName = () => {
	const {
		libertyMutualResult: {
			informations: { organization_name }
		}
	} = useLibertyMutualContext();

	return (
		<Col xs={24}>
			<Topic>{I18n.get('Company')}:</Topic>
			<Value>{organization_name}</Value>
		</Col>
	);
};
